import * as React from 'react';
import { Input } from 'antd';
import intl from 'react-intl-universal';
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed';

import './index.less';

export interface DescriptionItemProps {
    value?: any;
    onChange?: (value: any) => void;
    onFocus?: () => void;
    id?: string;
    desc?: string;
    scrollToview: (elem: HTMLElement | null) => void;
}

const { useEffect, useRef } = React;

const DescriptionItem: React.FC<DescriptionItemProps> = ({
    value,
    onChange,
    onFocus,
    id,
    desc,
    scrollToview,
    ...props
}) => {
    const wrapper = useRef<Element>(null);
    const currentScreenHeight = useRef(0);
    const handleTouchEvent = (e: Event) => {
        e.preventDefault();
        e.stopPropagation();
    };
    const handleFocus = () => {
        // @ts-ignore
        const elem = document.getElementById(id);
        document.body.classList.add('has-keyboard');
        setTimeout(() => {
            scrollToview(elem);
        }, 100);

        onFocus && onFocus();
    };
    const handleBlur = () => {
        document.body.classList.remove('has-keyboard');
    };
    const handleResize = React.useCallback(() => {
        const height = window.document.body.clientHeight;
        // 收起键盘
        if (height > currentScreenHeight.current) {
            if (document.body.classList.contains('has-keyboard')) {
                document.body.classList.remove('has-keyboard');
            }
        }
        // 弹起键盘
        if (height < currentScreenHeight.current) {
            if (!document.body.classList.contains('has-keyboard')) {
                document.body.classList.add('has-keyboard');
            }
        }
        currentScreenHeight.current = height;
    }, []);

    useEffect(() => {
        setTimeout(() => {
            // @ts-ignore
            wrapper.current = document.querySelector('.mobile__detail-wrapper');
        }, 100);
        currentScreenHeight.current = window.document.body.clientHeight;
    }, []);

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    return (
        <div id={id} className="mobile-questionnaire__form__textArea-wrapper">
            {desc && <div className="desc">{desc}</div>}
            <Input.TextArea
                value={value}
                onChange={onChange}
                placeholder={intl.get('pleaseEnter')}
                onFocus={handleFocus}
                onBlur={handleBlur}
                {...props}
            />
        </div>
    );
};

export default DescriptionItem;
